import { RoomId, roomId, StreamId, streamId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStageLayoutMainSetRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStageLayoutMainSetRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomStageLayoutMainSetRequest) {
    JsonSchemaValidator.assert(
      RoomStageLayoutMainSetRequestDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "streamId"],
      properties: {
        roomId,
        streamId
      },
      additionalProperties: false
    };
  }
}

interface RoomStageLayoutMainSetRequest {
  roomId: RoomId;
  streamId: StreamId;
}
